import { render, staticRenderFns } from "./View.vue?vue&type=template&id=900cd884&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('900cd884')) {
      api.createRecord('900cd884', component.options)
    } else {
      api.reload('900cd884', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=900cd884&", function () {
      api.rerender('900cd884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory/warehouse/View.vue"
export default component.exports